<template>
  <div class="upload-file">
    <div class="upload-file-title">
      <!--上传临时工名单-->
      <div class="file-title">{{ $t('userManage.UploadTheListOfTemporaryWorkers') }}</div>
      <!--请先下载标准模板，填写完成后再上传。不要修改表头名称或字段顺序。-->
      <div style="font-size: 14px">{{ $t('userManage.PleaseDownloadTheStandardTemplateFirst') }}</div>
    </div>
    <div style="padding: 20px">
      <div style="margin-bottom: 10px;">
        <el-upload
          ref="uploadFile"
          drag
          action=""
          :auto-upload="false"
          :file-list="fileList"
          :limit="1"
          :multiple="false"
          :show-file-list="false"
          :before-upload="beforeUploadFile"
          :on-exceed="onExceedFile"
          :on-change="onUploadChange"
          class="upload-temporary"
        >
          <div style="text-align: center;">
            <i class="el-icon-upload" style="margin-top: 10px;font-size: 50px" />
            <div class="el-upload__text">{{ $t('basicData.DragTheFileHereOrClickUpload') }}</div>
            <div class="el-upload__tip">{{ $t('userManage.SupportsXlsxXlsFiles') }}</div>
            <div style="padding: 10px 0">
              <el-button
                icon="el-icon-bottom" type="text"
                style="font-size: 16px;color: #0ca040"
                @click.stop="downloadModel"
              >{{ $t('userManage.DownloadExcelTemplate') }}</el-button>
            </div>
          </div>
        </el-upload>
      </div>
      <div v-if="fileList && fileList.length > 0" class="upload-file-list">
        <div class="file-list-icon">XLS</div>
        <div style="margin-left: 10px;flex: 1">
          <div style="font-size: 14px;font-weight: bold;">{{ fileList[0].name }}</div>
          <div style="font-size: 12px">{{ tableData.length }} {{ $t('userManage.dataPoints') }} · {{
            parseInt(fileList[0].size / 1024)
          }} KB</div>
        </div>
        <div class="delete-file">
          <!--删除-->
          <el-button type="text" @click="deleteFile">{{ $t('userManage.Delete') }}</el-button>
        </div>
      </div>
      <div class="account-validity">
        <!--账号时效-->
        <span style="font-weight: bold;margin-right: 5px;">{{ $t('userManage.AccountValidity') }}:</span>
        <!--每条临时工数据必须填写账号有效天数。账号达到失效时间后自动禁止登录，如需继续使用必须重新申请。-->
        <span>{{ $t('userManage.TheNumberOfDaysTheAccount') }}</span>
      </div>
      <div class="table-file-container">
        <!--Excel 必填字段-->
        <div class="table-file-text">{{ $t('userManage.ExcelRequiredFields') }}</div>
        <el-table :data="tableData" max-height="300">
          <!--姓名-->
          <el-table-column :label="$t('collectionCenter.compellation')" prop="realName" />
          <el-table-column label="CPF" prop="cpf" />
          <!--所属转运中心-->
          <el-table-column :label="$t('collectionCenter.owningTransitCenter1')" prop="siteName" />
          <!--岗位-->
          <el-table-column :label="$t('home.position')" prop="positionName" />
          <!--账号有效天数-->
          <el-table-column :label="$t('userManage.NumberOfDaysTheAccountIsValid')" prop="validDays" />
          <!--手机号-->
          <el-table-column :label="$t('orderCenterCont.MobilePhoneNumber')" prop="phone" />
          <!--备注-->
          <!--          <el-table-column :label="$t('basicData.remark')" prop="remark" />-->
        </el-table>
      </div>
    </div>
    <div style="display: flex;align-items: center;padding: 20px;border-top: 1px solid #ddd;">
      <!--“所属转运中心”需要在 Excel 中填写，系统会校验当前创建人是否拥有对应转运中心的账号创建权限。-->
      <div style="flex: 1;font-size: 14px">{{ $t('userManage.AffiliatedTransferCenter') }}</div>
      <div style="text-align: right;width: 200px;">
        <!--上传并校验-->
        <el-button type="primary" @click="uploadVerification">{{ $t('userManage.UploadAndVerify') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import ExcelJs from 'exceljs';
import { getFreelancerImportTemplateApi, getFreelancerImportValidateApi } from '@/api/user';
export default {
  name: 'UploadFile',
  props: {
    siteIdList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      fileList: [],
      tableData: []
    };
  },
  methods: {
    // 下载模板
    async downloadModel() {
      const data = await getFreelancerImportTemplateApi();
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = '临时工账号导入.xlsx';

      // 触发下载
      document.body.appendChild(link);
      link.click();

      // 清理
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    // 上传前
    beforeUploadFile(file, fileList) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
      const whiteList = ['xlsx'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // 上传文件只能是xlsx格式
        this.$message.error(this.$t('orderImport.uploadOnlyXlsx'));
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        // 上传文件大小不能超过 10MB
        this.$message.error(this.$t('collectionCenter.uploadNot10MB'));
        return false;
      }
    },
    // 删除文件
    deleteFile() {
      this.fileList = [];
      this.tableData = [];
    },
    // 上传数量限制
    onExceedFile(file, fileList) {
      if (fileList.length >= 1) {
        this.$message.error(this.$t('userManage.OnlyOneFileCanBeUploaded'));
        return false;
      }
    },
    // 上传变化
    onUploadChange(file, fileList) {
      this.fileList = fileList;
      this.parsePaymentExcel(file.raw);
    },
    // 文件转 ArrayBuffer
    fileToArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          resolve(e.target.result);
        };
        reader.onerror = (e) => {
          reject(new Error('文件读取失败'));
        };
        reader.readAsArrayBuffer(file);
      });
    },
    // 解析文件
    async parsePaymentExcel(rawFile) {
      try {
        const buffer = await this.fileToArrayBuffer(rawFile);
        const wb = new ExcelJs.Workbook();
        await wb.xlsx.load(buffer);
        const ws = wb.getWorksheet('Sheet1') || wb.worksheets[0];
        if (!ws) {
          return [];
        }
        const rows = [];
        ws.eachRow((row, rowNumber) => {
          const rowData = [];
          row.eachCell((cell, colNumber) => {
            // 处理单元格值
            rowData.push(cell.value || null);
          });
          if (rowNumber === 1) {
            rowData.push(this.$t('userManage.lineNumber'));
          } else {
            rowData.push(rowNumber);
          }
          rows.push(rowData);
        });
        const headerKey = {
          '姓名/Nome *': 'realName', // 姓名
          'CPF *': 'cpf', // cpf
          '所属转运中心名称/HUB *': 'siteName', // 所属转运中心
          '岗位/Cargo': 'positionName', // 岗位
          '账号有效天数/Dias de validade da conta *': 'validDays', // 账号有效天数
          '手机号/Número de celular': 'phone' // 手机号
          // [this.$t('basicData.remark')]: 'remark' // 备注
        };
        const headers = rows[0];
        const data = rows.slice(1).map(row => {
          const obj = {};
          headers.forEach((header, index) => {
            if (headerKey[header] === 'siteName') {
              obj[headerKey[header]] = row[index];
              obj['hubName'] = row[index];
              obj['siteId'] = row[index];
            } else {
              obj[headerKey[header]] = row[index];
            }
          });
          return obj;
        });
        this.tableData = data;
        return data;
      } catch (err) {
        this.$message.error(this.$t('basicData.excelParseFailed'));
        this.tableData = [];
        return [];
      } finally {
        this.parseLoading = false;
      }
    },
    // 上传校验
    async uploadVerification() {
      if (this.fileList.length > 0) {
        if (this.tableData && this.tableData.length > 0) {
          const formData = new FormData();
          formData.append('file', this.fileList[0].raw);
          const data = await getFreelancerImportValidateApi(formData);
          this.$emit('submitUploadFile', 2, data.data);
        } else {
          this.$message.error(this.$t('userManage.TheUploadedFileContentCannotBeEmpty'));
        }
      } else {
        this.$message.error(this.$t('userManage.PleaseUploadTheFile'));
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.upload-file {
  background:#fff;
  border-radius: 10px;
  border: 1px solid #ddd;
}
.upload-file-title {
  border-bottom: 1px solid #ccc;
  padding: 15px 20px;
}
.file-title {
  font-size: 17px;
  font-weight: bold;
  color:#000;
}
.upload-file-list {
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  padding: 10px;
  margin-bottom: 10px;
}
.file-list-icon {
  font-weight: bold;
  font-size: 15px;
  color: #089a4b;
  background:#f0f9f4;
  width: 40px;
  height: 40px;
  display:flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}
.delete-file {
  flex: 1;
  display:flex;
  align-items: center;
  justify-content: flex-end;
}
.account-validity {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  font-size: 14px;
  background:#f4f8fc;
  margin-bottom: 20px;
}
.table-file-container {
  border: 1px solid #ddd;
  border-radius: 10px;
  background:#f8fafc;
}
.table-file-text {
  font-weight: bold;
  font-size: 14px;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}
::v-deep .upload-temporary * {
  width: 100%;
}
.upload-temporary .el-button {
  width: auto !important;
}
.upload-temporary .el-upload-dragger {
  height: auto !important;
}
</style>
